<template>
    <router-link
        v-if="to !== null"
        :class="classes"
        :to="to"
    >
        <CoreIcon
            name="plus"
            size="16"
        />
        <span class="core-link-secondary__text">{{ translatedText }}</span>
    </router-link>
    <div
        v-else
        :class="classes"
        @click="handleClick"
    >
        <CoreIcon
            class="core-link-secondary__icon"
            name="plus"
            size="16"
        />
        <span class="core-link-secondary__text">{{ translatedText }}</span>
    </div>
</template>

<script>
import CoreIcon from './CoreIcon.vue'

export default {
    name: 'CoreLinkSecondary',

    components: {
        CoreIcon,
    },

    emits: ['click'],

    props: {
        text: {
            required: true,
            type: String,
        },

        to: {
            type: Object,
            default: null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'core-link-secondary': true,
                'core-link-secondary--disabled': this.disabled,
            }
        },

        translatedText() {
            return this.$t(this.text)
        },
    },

    methods: {
        handleClick() {
            if (this.to === null) {
                this.$emit('click')
            }
        },
    },
}
</script>

<style scope>
.core-link-secondary,
.core-link-secondary:visited {
    text-decoration: none;

    border: 1px solid transparent;
    display: flex;
    align-items: center;
    gap: 2.2rem;

    cursor: pointer;

    & > span.core-link-secondary__text {
        font-size: 1.6rem;
        padding: 0.1rem;
        line-height: 140%;
    }

    & > .core-link-secondary__icon {
        width: 32px;
        height: 32px;
        background-color: var(--color-primary-500);
        border-radius: 100px;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    &:hover .core-link-secondary__icon {
        background: var(--color-primary-400);
    }

    &:focus {
        border: 1px solid var(--color-primary-500);
    }

    &:active {
        color: var(--color-primary-500);
        border-bottom: 1px solid var(--color-primary-500);
    }
}
.core-link-secondary--disabled {
    & > .core-link-secondary__icon {
        background-color: var(--color-secondary-200);
    }
    &:hover .core-link-secondary__icon {
        background: var(--color-secondary-200);
    }
    &:active {
        border-bottom: 1px solid transparent;
    }
    cursor: not-allowed;
}
</style>
